import { Paper } from '@material-ui/core';
import CustomLink from 'components/CustomLink';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { APPLICANT, RETURNED, KEY_PATHNAME } from 'utility/lookup';
import { setItem } from 'storage';

const SLayout = styled.div`
    width: 23%;
    margin-bottom: 20px;
    margin-right: 2%;
`;

const SContentLayout = styled.div`
    padding: 10px;
    display: flex;
    justify-content: space-between;
`;

const SLeftContent = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    height: 50px;
`;

const SRightContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: flex-end;
`;

const SNameLayout = styled.div`
    margin-bottom: 10px;
`;

const SCountLayout = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const SExpiredCard = styled.div`
    margin-top: 10px;
    width: 100%;
    /* height: 20px; */
    background: #fff;
    display: flex;
    justify-content: space-between;
`;

const OverviewCard = ({ count, link, name, color, item }) => {
    const userRole = useSelector((state) => state.user.role);

    const handleClick = () => {
        setItem(KEY_PATHNAME, link);
    };
    return (
        <SLayout>
            <Paper>
                <SContentLayout>
                    <SLeftContent>
                        <div style={{ height: '100%', width: '3px', borderRadius: '1px', background: color }}></div>
                    </SLeftContent>
                    <SRightContent>
                        <SNameLayout>{name}</SNameLayout>
                        <CustomLink onClick={handleClick} to={link}>
                            <SCountLayout>{count}</SCountLayout>
                        </CustomLink>
                    </SRightContent>
                </SContentLayout>
            </Paper>

            {userRole === APPLICANT && item.name === RETURNED && (
                <>
                    <Paper>
                        <SExpiredCard>
                            <div style={{ padding: 10 }}>Expire in ≥ 30 days</div>
                            <div style={{ padding: 10 }}>
                                <CustomLink onClick={handleClick} to={link}>({item.notExpired})</CustomLink>
                            </div>
                        </SExpiredCard>
                    </Paper>
                    <Paper>
                        <SExpiredCard>
                            <div style={{ padding: 10 }}>{'Expire in < 30 days'}</div>
                            <div style={{ padding: 10 }}>
                                <CustomLink onClick={handleClick} to={link}>({item.willExpired})</CustomLink>
                            </div>
                        </SExpiredCard>
                    </Paper>
                </>
            )}
        </SLayout>
    );
};

export default OverviewCard;
